var _rect, _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.0001,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5724_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0984252 7.80075L3.53905 4.33201C3.6492 4.22185 3.82733 4.22185 3.93749 4.33201L4.40155 4.79607C4.5117 4.90623 4.5117 5.08435 4.40155 5.19451L1.62421 7.99997L4.40155 10.8054C4.5117 10.9156 4.5117 11.0937 4.40155 11.2039L3.93749 11.6679C3.82733 11.7781 3.6492 11.7781 3.53905 11.6679L0.0984252 8.19919C-0.0117309 8.08903 -0.0117309 7.91091 0.0984252 7.80075Z",
    fill: "#9DCC3D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5724_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09843 7.80075L4.53905 4.33201C4.6492 4.22185 4.82733 4.22185 4.93749 4.33201L5.40155 4.79607C5.5117 4.90623 5.5117 5.08435 5.40155 5.19451L2.62421 7.99997L5.40155 10.8054C5.5117 10.9156 5.5117 11.0937 5.40155 11.2039L4.93749 11.6679C4.82733 11.7781 4.6492 11.7781 4.53905 11.6679L1.09843 8.19919C0.988269 8.08903 0.988269 7.91091 1.09843 7.80075Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5724_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4016 8.19925L11.961 11.668C11.8508 11.7781 11.6727 11.7781 11.5625 11.668L11.0985 11.2039C10.9883 11.0938 10.9883 10.9156 11.0985 10.8055L13.8758 8.00003L11.0985 5.19456C10.9883 5.0844 10.9883 4.90628 11.0985 4.79612L11.5625 4.33206C11.6727 4.22191 11.8508 4.22191 11.961 4.33206L15.4016 7.80081C15.5117 7.91097 15.5117 8.08909 15.4016 8.19925Z",
    fill: "#9DCC3D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_5724_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4016 8.19925L10.961 11.668C10.8508 11.7781 10.6727 11.7781 10.5625 11.668L10.0985 11.2039C9.9883 11.0938 9.9883 10.9156 10.0985 10.8055L12.8758 8.00003L10.0985 5.19456C9.9883 5.0844 9.9883 4.90628 10.0985 4.79612L10.5625 4.33206C10.6727 4.22191 10.8508 4.22191 10.961 4.33206L14.4016 7.80081C14.5117 7.91097 14.5117 8.08909 14.4016 8.19925Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5724_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 12,
    fill: "white",
    transform: "translate(0 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5724_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 12,
    fill: "white",
    transform: "translate(1 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5724_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 12,
    fill: "white",
    transform: "translate(15.5 14) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_5724_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 12,
    fill: "white",
    transform: "translate(14.5 14) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebServices);
export default __webpack_public_path__ + "static/media/web_services.5bbe77738159911ffa63f4cb0ce02388.svg";
export { ForwardRef as ReactComponent };